export const createFreeClaimMessageToSign = (walletAddress: string) => {
  return `I want to claim this NFT.\n\nMy wallet address is ${walletAddress.toLowerCase()}`;
};
